import React from "react";

type CheckboxFieldProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    // Optional gray text shown after the label (e.g. current value)
    hint?: React.ReactNode;
};

/**
 * Checkbox in a bordered box with a clickable label (the whole row)
 */
const CheckboxField: React.FC<CheckboxFieldProps> = ({ label, checked, onChange, disabled = false, hint }) => {
    return (
        <div className="px-4 border border-gray-300 rounded-sm my-2">
            <label className={`flex items-center gap-2 min-h-12 ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                    className="h-4 w-4 accent-blue-600"
                />
                <span className="text-sm">{label}</span>
                {hint && <span className="text-xs text-gray-400">{hint}</span>}
            </label>
        </div>
    );
};

export default CheckboxField;
